/**
 * inferBriefSection — best-effort mapping of a brief mod to the section of
 * the BriefWorkspace Document lens it should land on. Pure heuristic — the
 * BriefWorkspace handles unknown sections by scrolling to the top.
 */

export function inferBriefSection(mod: Record<string, unknown>): string {
  const titleRaw = (
    (mod.recommendation as Record<string, unknown> | undefined)?.title ??
    mod.suggested_change ??
    mod.element ??
    ''
  ) as string;
  const title = titleRaw.toLowerCase();

  if (title.includes('headline') || title.includes('copy') || title.includes('cta')) {
    return 'message';
  }
  if (title.includes('audience') || title.includes('persona')) {
    return 'audience';
  }
  if (title.includes('visual') || title.includes('image') || title.includes('scene')) {
    return 'creative_context';
  }
  if (title.includes('proof') || title.includes('trust')) {
    return 'mandatories';
  }
  return 'creative_context';
}
